<template>
<div :class="['micad_formElement micad_formElement_textBoxMoney',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <div class="micad_formElement_sign">£</div>
        <input type="text" class="micad_formElement_control_input" value="123,456">
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Text-box-money',
  data() {
    return {
        label: "Quisque tristique.",
        message: "Quisque tristique quis leo vitae luctus.",
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
